@if(showTable) {
<p-table #dataTable [globalFilterFields]="[
            'pbm_order_id', 
            'route_name', 
            'bl_name', 
            'address',
            'postal_code',
            'task_point_name',
            'item_count',
            'delivery_point_area_name',
            'goods_count',
            'driver_instruction',
            'manager_instruction',
            'reason_code',
            'user_name',
            'vehicle_type',
            'source',
            'task_type',
            'task_state',
            'task_time_window'
        ]"  dataKey="id"  
        [(selection)]="taskMovementService.selectedOptionsForTaskMove"
        [resizableColumns]="true"
        [value]="plannedPbmData" [columns]="visibleColumns" 
        [rowHover]="true"  
        sortMode="multiple"
        [metaKeySelection]="taskInfoService.metaKey"
        [scrollable]="true"
        scrollHeight="flex" 
        columnResizeMode="expand"
        (onColResize)="saveColumnWidth($event)"
        [virtualScroll]="true"
        [virtualScrollItemSize]="35"
        [style]="{width:'100%'}"
        dataKey="task_id"
        [loading]="taskInfoService.loading"
        [multiSortMeta]="taskInfoService.multiSortMetaIndexCol"
        selectionMode="multiple" [tableStyle]="{'table-layout': 'fixed'}"
        (onHeaderCheckboxToggle)="onSelectAllToggle($event)"
        (onRowSelect)="onTaskSelection($event.data)"
        (onRowUnselect)="onTaskUnselection($event.data)"
        [customSort]="isCustomSort"
        (onSort)="onColumnSort($event)">
    <ng-template pTemplate="loadingicon">
        <svg id="ag-loading-overlay" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
            <circle class="circle" cx="12" cy="12" r="10" stroke-width="3" stroke="#3A5487"></circle>
            <circle class="dot" cx="21.3" cy="16" r="1.48" fill="#3A5487"></circle>
        </svg>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th style="width: 1.5rem" id="rowHighlight-header" [ngClass]="{'custom-sort-icon':taskInfoService.router.url != navigation.MapLeaflet, 'custom-sort-mapview':taskInfoService.router.url == navigation.MapLeaflet}">
                @if(taskMovementService.taskmoveCount()){
                    <div>
                       <img [src]="sortingService.isCustomSortApplied ? '../../../../../../assets/image/sort_selected.svg' : '../../../../../../assets/image/sort.svg'" (click)="setSelectedTaskSorting()"
                        class="icons-task-bank" onKeyDown="setSelectedTaskSorting()"
                        pTooltip="To sort by selected tasks" [hidden]="isSelectAll"/>
                    </div>
                }
            </th>
            <ng-container>
                <th id="rowHighlight-header" style="width: 2.5rem">S.No.
                </th>
            </ng-container>
            <!-- Hide Pull Back Since APP has issue to fixed-->
            <th id="checkbox-header"style="width: 2.7rem;">
                @if (favList === "default" && (dataTable.filteredValue??plannedPbmData | selectionRowAllowed)) {
                    <p-tableHeaderCheckbox ></p-tableHeaderCheckbox>
                }
            </th>
            <th id="indicators-header" style="width: 3.5rem;">
                <i class="pi pi-flag"  pTooltip="Shipment Indicators"></i>
            </th>
            <ng-container *ngFor="let column of visibleColumns">
                <th *ngIf="column.field !== 'task_time_window' && column.field !== 'task_state' && column.field !== 'pbm_order_id' " pResizableColumn [ngStyle]="{'width': column.width}" [id]="column.field"  [pSortableColumn]="column.field">
                    {{column.label}}<p-sortIcon [field]="column.field" />
                </th>
                <th *ngIf="column.field === 'pbm_order_id'" pResizableColumn  [ngStyle]="{width: column.width}"  [id]="column.field" scope="col" [pSortableColumn]="column.field">
                    {{column.label}}
                    <p-sortIcon class="me-1" [field]="column.field" />
                    <p-columnFilter #orderColumnFilter field="pbm_order_id" matchMode="startsWith" [showApplyButton]="false" display="menu" [showAddButton]="false" 
                        [showOperator]="false" 
                        [showMatchModes]="false"
                        [showClearButton]="false">
                        <ng-template
                          pTemplate="filter"
                          let-value
                          let-filterCallback="filterCallback"
                        >
                          <p-select
                            [ngModel]="value"
                            [options]="pbmOrderType"
                            optionLabel="name" optionValue="value" 
                            [style]="{width:'100%'}"
                            (onChange)="onColumnFilterChange($event.value, filterCallback, columnFilterKeys.PbmOrderType)"
                            placeholder="All"
                          > 
                            <ng-template let-option pTemplate="item">
                                <span>{{option.name}}</span>
                            </ng-template>
                          </p-select>
                        <button type="button"  label="Clear" class="pn-button pn-button-primary mt-3 p-2 w-auto"
                            (click)="onColumnFilterChange(null, filterCallback, columnFilterKeys.PbmOrderType)">Clear</button>
                    </ng-template>
                    </p-columnFilter>
                </th>
                <th *ngIf="column.field === 'task_state'" pResizableColumn  [ngStyle]="{width: column.width}"  [id]="column.field" scope="col" [pSortableColumn]="column.field">
                    {{column.label}}
                    <p-sortIcon class="me-1" [field]="column.field" />
                    <p-columnFilter #statusColumnFilter field="task_state" matchMode="in" [showApplyButton]="false" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" [showClearButton]="false">
                        <ng-template pTemplate="filter" let-value let-filterCallback="filterCallback">
                            <p-multiSelect [ngModel]="value" [options]="statuses" placeholder="All" 
                            optionValue="name"  [filter]="false" [showHeader]="false" [style]="{width:'100%'}" [maxSelectedLabels]="2"
                            (onChange)="onColumnFilterChange($event.value, filterCallback, columnFilterKeys.TaskStatus)" optionLabel="name">
                                <ng-template let-option pTemplate="item">
                                    <div class="flex align-items-center gap-2">
                                        <div>{{ option.name }}</div>
                                    </div>
                                </ng-template>
                            </p-multiSelect>
                            <button type="button" class="pn-button pn-button-primary mt-3 p-2 w-auto"
                                (click)="onColumnFilterChange(null, filterCallback, columnFilterKeys.TaskStatus)">Clear</button>
                        </ng-template>
                    </p-columnFilter>
                </th>
                <th *ngIf="column.field === 'task_time_window'" pResizableColumn  [ngStyle]="{'width': column.width}" [id]="column.field" pSortableColumn="task_time_window">
                    {{column.label}}<p-sortIcon field="task_time_window" />
                </th>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowIndex="rowIndex" let-plannedPbmData>
        <tr [pSelectableRowDisabled]="!plannedPbmData.isMovementAllowed"
        [pSelectableRow]="plannedPbmData.isMovementAllowed ? plannedPbmData : null" [pSelectableRowIndex]="rowIndex">
            <td id="rowHighlight-header" class="custom-sort-icon"></td>
            <ng-container >
                <td><span>{{plannedPbmData.index}}</span></td>
            </ng-container>
            <!-- Hide Pull Back Since APP has issue to fixed-->
            <td>
                <ng-container *ngIf="plannedPbmData.isMovementAllowed; else showErrorMsg">
                    <p-tableCheckbox [pSelectableRow]="plannedPbmData" [value]="plannedPbmData"></p-tableCheckbox>
                </ng-container>
                <ng-template #showErrorMsg>
                    <i class="pi pi-info-circle info-icon" [pTooltip]="taskInfoService.taskMovementErrorMsg" appendTo="body" autoHide="false" tooltipStyleClass="taskmovement-error-tooltip"></i>
                </ng-template>
            </td>
            <td class="indicator-cell">
                <div class="indicator-rail">
                    @for(indicator of plannedPbmData?.indicators; track indicator.key; let i = $index) {
                        @if(i < 2) {
                            <img [src]="indicator.icon"
                                [pTooltip]="indicator.label"
                                tooltipPosition="bottom"
                                class="indicator-icon"
                                width="16" height="16"
                                [alt]="indicator.label" />
                        }
                    }
                    @if(plannedPbmData?.indicators?.length > 2) {
                        <span class="indicator-overflow"
                            (click)="showIndicatorPanel($event, plannedPbmData); $event.stopPropagation()">
                            +{{plannedPbmData.indicators.length - 2}}
                        </span>
                    }
                </div>
            </td>
            <ng-container  *ngFor="let col of visibleColumns">
                <td *ngIf="col.field !== 'pbm_order_id' &&
                    col.field !== 'item_count' &&
                    col.field !== 'task_time_window' &&
                    col.field !== 'task_state' &&
                    col.field !== 'goods_count' &&
                    col.field !== 'manager_instruction'"
                    class="wrapRowData" 
                    [pTooltip]="plannedPbmData[col.field]"
                    tooltipPosition="bottom">
                    {{plannedPbmData[col.field]}}
                </td>
                <td *ngIf="col.field === 'pbm_order_id'">
                    <div class="d-flex align-items-center">
                        <!--commented out this code for future use-->
                        <!-- @if(plannedPbmData.label_less_pickup) {
                                <img src="assets/image/label_less_pickup.png" 
                                pTooltip="Label Less Pickup" class="align-middle label-less-icon" width="13" height="13" alt="label_less_pickup" />
                        } -->
                        <i class="pi pi-search glass-icon" (click)="PBMlookup(plannedPbmData.pbm_order_id);$event.stopPropagation()"
                        pTooltip="Open PBM Lookup" style="margin-right: .2rem; font-size: .6rem;"></i>
                        <a class="anchor" href="void:()"
                        [style.--orderColor]="plannedPbmData?.pbm_order_id | orderIdColor : plannedPbmData?.external_keys?.is_swedish_election_order"
                        (click)="taskInfoService.editPickupOrder(plannedPbmData); $event.stopPropagation();">{{plannedPbmData.pbm_order_id}}</a>
                    </div>
                </td>
                <td *ngIf="col.field === 'item_count'" (click)="openItemDialog(plannedPbmData, 'items'); $event.stopPropagation();" [ngClass]="{'pointer-cursor': plannedPbmData.item_count > 0}">
                    <a *ngIf="plannedPbmData.item_count > 0" href="javascript:void(0)"
                        >{{plannedPbmData.item_count}}</a>
                    <span *ngIf="plannedPbmData.item_count === 0">{{plannedPbmData.item_count}}</span>
                </td>
                <td *ngIf="col.field === 'manager_instruction'" class="wrapRowData" [pTooltip]="plannedPbmData.manager_instruction" tooltipPosition="bottom">
                   <button (click)="taskInfoService.showDialog(plannedPbmData,'manager', 'TaskBank'); $event.stopPropagation()" class="pi pi-pencil edit-icon"></button>
                   {{plannedPbmData.manager_instruction}}
                </td>

                <td *ngIf="col.field === 'goods_count'" [pTooltip]="plannedPbmData.good_types" tooltipPosition="bottom"
                    (click)="openItemDialog(plannedPbmData, 'goods'); $event.stopPropagation();" [ngClass]="{'pointer-cursor': plannedPbmData.goods_count > 0}">
                    <a *ngIf="plannedPbmData.goods_count > 0" href="javascript:void(0)"
                        >{{plannedPbmData.goods_count}}</a>
                    <span *ngIf="plannedPbmData.goods_count === 0">{{plannedPbmData.goods_count}}</span>
                </td>
                <td *ngIf="col.field === 'task_time_window'" >{{plannedPbmData.task_time_window}}</td>
                <td *ngIf="col.field === 'task_state'"><span [ngStyle]="plannedPbmData.task_state | TaskState">{{plannedPbmData.task_state}}</span></td>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="visibleColumns.length + 4">
                <div class="text-center no-record-label">
                    No Records found.
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>
}
<div class="taskBankSummary">
    <div>Total <b>{{plannedPbmData.length}}</b> Tasks</div>

    @if(taskMovementService.taskmoveCount()){
        <img [src]="taskMovementService.showSelectedTaskKPI ? '../../../../../../assets/image/flip_icon_selected.svg' : '../../../../../../assets/image/flip_icon.svg'"
            (click)="taskMovementService.toggleIconRotation()"
            class="icons-task-bank"/>
        }
    @if(taskMovementService.taskmoveCount() && !taskMovementService.showSelectedTaskKPI){
        <div>
            <p-tag value="{{taskMovementService.taskmoveCount()}} {{taskMovementService.taskmoveCount() == 1 ? 'task' : 'tasks'}} selected" 
            class="primary-chip"/>
        </div>
        @for(kpi of taskMovementService.selectedTaskKPI; track kpi){
            @if(kpi.key==='task_type'){
            <div class="kpi-footer-props" [pTooltip]="kpi.value.toString()" tooltipPosition="top">{{kpi.key | removeUnderscore | titlecase }} : <b>{{kpi.value}}</b></div>
            }
            @else {
            <div>{{kpi.key | removeUnderscore | titlecase }} : <b>{{kpi.value}}</b>
            </div>
            }

        }
    }
    @else {
        <div><b>{{ plannedPbmData | taskskpicountPipe : taskType.Pickup }}</b> Pickup</div>
        <div><b>{{ plannedPbmData | taskskpicountPipe : taskType.Deliver }}</b> Delivery</div>
        <div><b>{{ plannedPbmData | taskskpicountPipe : taskType.Visit}}</b> Visit</div>
        <div><b>{{ plannedPbmData | taskskpicountPipe : taskType.Break }}</b> Break</div>
        <div><b>{{ plannedPbmData | taskskpicountPipe : taskType.Myboxpickup }}</b> MyBoxPickup</div>
        <div><b>{{ plannedPbmData | taskskpicountPipe : taskType.Emptymailbox }}</b> EmptyMailBox</div>
        <app-color-legends [colorlegends]="tbLegends"></app-color-legends>
    }
</div>
<p-dialog header="{{header}}" [(visible)]="displayItemDialog" [modal]="true"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '80vw' }" [draggable]="false"
    [resizable]="false">
    <app-item-details *ngIf="displayItemDialog" [additionalData]="additionalData"></app-item-details>
</p-dialog>

@if(DialogType === 'TaskBank') {
    <p-dialog header="Update Manager Notes" [(visible)]="taskInfoService.updatePopup.showPopup" [modal]="true" [style]="{ width: '40vw' }"
    [resizable]="false"  (onHide)="closeDialog(true)">
        <app-update-manager-notes #managerNotesPlannedPBM  [task]="taskInfoService.updatePopup.updateTask" (closeDialog)="closeDialog($event); refreshActiveTabData()">
        </app-update-manager-notes>
        <ng-template #footer>
            <ng-container *ngTemplateOutlet="managerNotesPlannedPBM.managerNotesFooter"></ng-container>
        </ng-template>
    </p-dialog>
}

<p-popover #indicatorPanel [dismissable]="true" [style]="{width: '220px'}">
    <div class="indicator-panel-list">
        @for(indicator of activeIndicators; track indicator.key) {
            <div class="indicator-panel-row">
                <img [src]="indicator.icon" width="16" height="16" [alt]="indicator.label" />
                <span>{{indicator.label}}</span>
            </div>
        }
    </div>
</p-popover>